/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { clearCallbackAttempts } from "./callback.attempts";
import { Text, Title, Button } from "@/shared/ui";
import { useTranslation } from "react-i18next";

/**
 * CallbackErrorScreen component shown when authentication fails after retries.
 *
 * @param props - Component props.
 * @param props.navigate - Navigation callback used to send the user to another route.
 * @returns {JSX.Element} React component element
 */
export function CallbackErrorScreen({ navigate }: { navigate: (path: string) => void }) {
  const { t } = useTranslation("@pages/error");
  return (
    <div
      data-testid="callback-error"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <Title order={1} style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>
        {t("callback.title")}
      </Title>
      <Text style={{ fontSize: '1rem', color: 'var(--text-tertiary)', marginBottom: '2rem', maxWidth: '400px' }}>
        {t("callback.description")}
      </Text>
      <Button
        variant="none"
        disableSize
        onClick={() => {
          clearCallbackAttempts();
          navigate("/");
        }}
        style={{
          padding: '0.75rem 2rem',
          fontSize: '1rem',
          backgroundColor: 'var(--button-primary-bg)',
          color: 'var(--button-primary-text)',
          border: 'none',
          borderRadius: 'var(--radius-md)',
          cursor: 'pointer',
        }}
      >
        {t("callback.goHome")}
      </Button>
    </div>
  );
}
